import React, { Component } from "react";
import PropTypes from "prop-types";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import Snackbar from "@material-ui/core/Snackbar";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { Grid } from "@material-ui/core";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import { DeletePaymentType, GetPaymentTypes } from "../../fetchs";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AlertDialog from "../Prompt/alert-dialog.component";
import CircularProgress from "@material-ui/core/CircularProgress";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./payment-type-list.styles.css";

const headCells = [
  { id: "index", numeric: false, disablePadding: true, label: "ردیف" },
  { id: "name", numeric: false, disablePadding: true, label: "نام" },
  { id: "tools", numeric: false, disablePadding: true, label: "" },
];

const EnhancedTableHead = () => {
  //const { classes } = props;

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "default"}
          >
            <TableSortLabel active={false}>{headCell.label}</TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default class PaymentTypeList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      rowsPerPage: 20,
      rowsLength: 0,
      rows: [],
      alertDialog: false,
      deleteId: null,
      loading: false,
      openSnackbar: false,
      errorMessage: "",
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount() {
    this.getPaymentTypes();
  }

  getPaymentTypes = () => {
    this.setState({ loading: true });
    GetPaymentTypes(this.state.page, this.state.rowsPerPage)
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else
          this.setState({
            rows: responseJson.data,
            rowsLength: responseJson.count,
          });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.getPaymentTypes();
    });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 }, () => {
      this.getPaymentTypes();
    });
  };

  handleDelete = () => {
    this.setState({ alertDialog: false, loading: true });
    DeletePaymentType(this.state.deleteId)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status === 200)
          toast.success("نوع پرداخت با موفقیت حذف شد");
        else toast.error("خطای حذف نوع پرداخت");
        this.getPaymentTypes();

        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handlePrepareDelete = (id) => {
    this.setState({ deleteId: id, alertDialog: true });
  };

  handleCloseDialog = () => {
    this.setState({ alertDialog: false });
  };

  emptyRows = () =>
    this.state.rowsPerPage -
    Math.min(
      this.state.rowsPerPage,
      this.state.rowsLength - this.state.page * this.state.rowsPerPage
    );

  render() {
    const { classes } = this.props;
    return (
      <div className='root'>
        <Paper className='paper'>
          <Toolbar>
            <Grid item xs={12} sm={2}>
              <div className='title'>
                {
                  <Typography variant='h6' id='tableTitle'>
                    لیست نحوه پرداخت ها
                  </Typography>
                }
              </div>
            </Grid>
            <Grid item xs={12} sm={8}></Grid>
            <Grid item xs={12} sm={2}>
              <Link to='/main/paymentType' className='link'>
                <Button variant='contained' color='primary'>
                  ساخت نحوه پرداخت جدید
                </Button>
              </Link>
            </Grid>
          </Toolbar>
          <div className='tableWrapper'>
            <Table
              className='table'
              aria-labelledby='tableTitle'
              size={"medium"}
            >
              <EnhancedTableHead
                classes={classes}
                numSelected={0}
                rowCount={this.state.rowsLength}
              />
              <TableBody>
                {this.state.rows.map((row, index) => {
                  return (
                    <TableRow hover tabIndex={-1} key={row.id}>
                      <TableCell align='center'>
                        {this.state.page * this.state.rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell align='center'>{row.name}</TableCell>
                      <TableCell align='center'>
                        <Link to={`/main/paymentType/${row.id}`}>
                          <EditIcon color='primary' />
                        </Link>
                        <DeleteIcon
                          className='deleteIcon'
                          onClick={() => this.handlePrepareDelete(row.id)}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
                {this.emptyRows > 0 && (
                  <TableRow style={{ height: 49 * this.emptyRows }}>
                    <TableCell colSpan={2} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          {this.state.loading && (
            <CircularProgress size={24} className='buttonProgress' />
          )}
          <TablePagination
            rowsPerPageOptions={[20, 50, 100]}
            component='div'
            count={this.state.rowsLength}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            backIconButtonProps={{
              "aria-label": "previous page",
            }}
            nextIconButtonProps={{
              "aria-label": "next page",
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
        <AlertDialog
          open={this.state.alertDialog}
          title={`اخطار`}
          body={`آیا از حذف نحوه پرداخت اطمینان دارید؟`}
          handleYes={this.handleDelete}
          handleNo={this.handleCloseDialog}
        />
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          autoHideDuration={3000}
          open={this.state.openSnackbar}
          ContentProps={{
            "aria-describedby": "message-id",
            class:
              "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
          }}
          message={<span id='message-id'> {this.state.errorMessage} </span>}
          onClose={() => this.handleCloseSnackbar(false)}
        />
      </div>
    );
  }
}
